/**
 * Visibility Labs color palette.
 * Centralized color definitions for consistent theming across the application.
 */

const colors = {
  // Background Colors
  bg: {
    primaryPurple: 'rgb(122, 102, 255)',       // #7A66FF
    lightLavender: 'rgb(244, 243, 252)',        // #F4F3FC
    offWhite: 'rgb(249, 249, 253)',             // #F9F9FD
    white: 'rgb(255, 255, 255)',                // #FFFFFF
    softLavender: 'rgb(241, 240, 251)',         // #F1F0FB
    paleLavender: 'rgb(249, 248, 253)',         // #F9F8FD
    darkNavy: 'rgb(23, 15, 73)',               // #170F49
    darkOverlay: 'rgba(0, 0, 0, 0.85)',
    black: 'rgb(0, 0, 0)',                     // #000000
  },

  // Text Colors
  text: {
    black: 'rgb(0, 0, 0)',                     // #000000
    danger: 'rgb(185, 28, 28)',                // #B91C1C — destructive actions
    link: 'rgb(0, 0, 238)',                    //rgb(112, 112, 255)
    darkNavy: 'rgb(23, 15, 73)',               // #170F49
    white: 'rgb(255, 255, 255)',               // #FFFFFF
    muted: 'rgb(81, 79, 110)',                 // #514F6E
    accentBlue: 'rgb(84, 72, 218)',            //rgb(84, 72, 218)
    purple: 'rgb(139, 92, 246)',               // #8B5CF6
    subtleBlue: 'rgba(13, 40, 98, 0.65)',
    softPurple: 'rgb(122, 101, 253)',          // #7A65FD
    gray: 'rgb(170, 170, 170)',                // #AAAAAA
  },

  // Border Colors
  border: {
    black: 'rgb(0, 0, 0)',                     // #000000
    link: 'rgb(0, 0, 238)',                    // #0000EE
    darkNavy: 'rgb(23, 15, 73)',               // #170F49
    lightNavy: 'rgba(23, 15, 73, 0.08)',
    accentBlue: 'rgb(74, 58, 255)',            // #4A3AFF
    purple: 'rgb(139, 92, 246)',               // #8B5CF6
    muted: 'rgb(81, 79, 110)',                 // #514F6E
    subtleBlue: 'rgba(13, 40, 98, 0.65)',
    white: 'rgb(255, 255, 255)',               // #FFFFFF
    softPurple: 'rgb(122, 101, 253)',          // #7A65FD
    light: 'rgb(239, 239, 239)',               // #EFEFEF
    cyan: 'rgb(0, 160, 210)',                  // #00A0D2
    whiteTranslucent: 'rgba(255, 255, 255, 0.4)',
    gray: 'rgb(170, 170, 170)',                // #AAAAAA
  },

  // 180 Marketing brand palette
  marketing: {
    green: '#A2CF4F',                 // --marketing-green
    greenSecondary: '#9CCB3B',        // --marketing-green-secondary
    greenHover: '#8FB843',            // --marketing-green-hover
    charcoal: '#545557',              // --marketing-charcoal
    deepCharcoal: '#242629',          // --marketing-deep-charcoal
    greyLight: '#6A6A6D',             // --marketing-grey-light
    greyMuted: '#737678',             // --marketing-grey-muted
    borderGrey: '#D9DDD5',            // --marketing-border-grey
    borderDark: '#B8BDB3',            // --marketing-border-dark
    background: '#F5F6F4',            // --marketing-background
    greenSoft: '#F3F8E9',             // --marketing-green-soft
    white: '#FBFBFB',                 // --marketing-white
    pureWhite: '#FFFFFF',             // --marketing-pure-white
  },
};

export default colors;
